import React from 'react';
import { Stepper, Step, StepLabel, StepConnector, withStyles } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import StopName from './StopName';
import StopIcon from './StopIcon';
import { ACTIVE_DETAILS } from '../../../constants';

const styles = (theme) => ({
  connectorActive: {
    padding: 0,
    maxHeight: 20,
    marginLeft: 12,
    marginTop: -35,
    marginBottom: 35,
    '& span$connectorLine': {
      height: 90,
      borderLeft: `2px solid ${theme.HeaderSelectedText}`
    }
  },
  connectorCompleted: {
    padding: 0,
    maxHeight: 20,
    marginLeft: 12,
    marginTop: -35,
    marginBottom: 35,
    '& span$connectorLine': {
      height: 90,
      borderLeft: `2px solid ${theme.HeaderSelectedText}`
    }
  },
  connectorDisabled: {
    padding: 0,
    maxHeight: 20,
    marginLeft: 12,
    marginTop: -35,
    marginBottom: 35,
    '& span$connectorLine': {
      height: 90,
      borderLeft: `2px dotted ${theme.HeaderSelectedText}`
    }
  },
  stepperClass: {
    height: '70%',
    minHeight: 200,
    padding: 0,
    marginTop: 12,
    marginLeft: 10,
    overflowY: 'auto',
    overflowX: 'hidden',
    background: theme.gridBGColor
  },
  connectorLine: {
    height: 44
  },
  stepperFullClass: {
    height: '80%',
    minHeight: 200,
    padding: 0,
    marginTop: 20,
    marginLeft: 10,
    overflow: 'auto',
    background: theme.gridBGColor
  },
  iconStyle: {
    fontSize: 14,
    color: theme.HeaderSelectedText,
    padding: 4,
    border: `1px solid ${theme.HeaderSelectedText}`,
    borderRadius: '50%'
  },
  otherBreakIconStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.HeaderSelectedText,
    width: 24,
    height: 20,
  },
  iconContainer: {
    zIndex: 1,
    background: theme.gridBGColor
  },
  labelContainer:{
    zIndex: 2,
  },

});
const StopStepper = ({
  classes,
  steps,
  activeStep,
  activeDetail,
  onStopSelectionChange,
  stepRef,
  isLiveDispatch,
  route,
  DispatchStore
}) => {
  // DispatchStore is imported in this parent component and passed down to this component to help improve performance.
  const staticClientStatusLists = {
    deliveryStatusList: DispatchStore?.deliveryStatuses || [],
    exceptionList: DispatchStore?.exceptions || [],
    returnCodeList: DispatchStore?.returnCodes || []
  };
  const connector = (
    <StepConnector
      classes={{
        active: classes.connectorActive,
        completed: classes.connectorCompleted,
        disabled: classes.connectorDisabled,
        line: classes.connectorLine
      }}
    />
  );

  const onStepClick = (index) => {
    return activeDetail === ACTIVE_DETAILS.STOP ? onStopSelectionChange(index) : null;
  };

  const getPendingStepIndex = (steps) => {
    if (isLiveDispatch) {
      const stepIndex = steps.findIndex((step) => !step.isStopCompleted);
      return stepIndex === -1 ? steps.length - 1 : stepIndex - 1;
    }
    return steps.length - 1;
  };

  return (
    <div ref={stepRef}>
      <Stepper
        activeStep={getPendingStepIndex(steps)}
        classes={{
          root:
            activeDetail === ACTIVE_DETAILS.STOP ? classes.stepperClass : classes.stepperFullClass
        }}
        className="customScroll"
        orientation="vertical"
        connector={connector}>
        {steps.map((stop, index) => {
          const isActiveStep =
            activeDetail === ACTIVE_DETAILS.STOP && activeStep === stop.routeMaxUIStopIndex;
          const isDelayStop = Boolean(stop.isRouteLevelDelayStop);
          return (
            <Step
              id={`stopStep-${index}`}
              key={stop.stopId}
              onClick={() => (isDelayStop ? null : onStepClick(stop.routeMaxUIStopIndex))}
              completed={stop.isStopCompleted}
              disabled={isDelayStop}>
              <StepLabel
                classes={{
                  iconContainer: classes.iconContainer,
                  labelContainer: classes.labelContainer
                }}
                icon={<StopIcon stop={stop} active={isActiveStep} classes={classes} />}>
                <StopName
                  stopData={stop}
                  active={isActiveStep}
                  isDelayStop={isDelayStop}
                  route={route}
                  staticClientStatusLists={staticClientStatusLists}
                  DispatchStore={DispatchStore}
                />
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};
export default inject('DispatchStore')(observer(withStyles(styles)(StopStepper)));
